<template>
  <div class="black-inputs">
    <el-row>
      <el-col :span="10" :offset="1">
        <el-form ref="dataClientForm" :rules="rulesFormPart1" :model="dataClient" label-width="0px">
          <el-form-item class="civ">
            <el-radio-group v-model="dataClient.civ">
              <el-radio-button label="M."></el-radio-button>
              <el-radio-button label="Mme"></el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item prop="clientPreFix" class="cPrefix">
            <el-input v-model="dataClient.clientPreFix" placeholder="Préfixe"></el-input>
          </el-form-item>
          <el-form-item prop="name">
            <el-input v-model="dataClient.name" placeholder="Nom*"></el-input>
          </el-form-item>
          <el-form-item prop="prenom">
            <el-input v-model="dataClient.prenom" placeholder="Prénom*"></el-input>
          </el-form-item>
          <el-form-item prop="email">
            <el-input v-model="dataClient.email" placeholder="e-mail*"></el-input>
          </el-form-item>
          <el-form-item prop="telPreFix" class="tel-prefix">
            <el-input v-model="dataClient.telPreFix" placeholder="+33"></el-input>
          </el-form-item>
          <el-form-item prop="tel" class="tel">
            <el-input v-model="dataClient.tel" placeholder="Téléphone*"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="dataClient.societe" placeholder="Société"></el-input>
          </el-form-item>
          <el-form-item class="checkbox-green" label-width="auto" label="Offres promotionnelles (rgpd) :">
            <div class="content">
              <el-checkbox v-model="dataClient.rgpdmail">E-mail</el-checkbox>
              <el-checkbox v-model="dataClient.rgpdsms">SMS</el-checkbox>
            </div>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="10" :offset="1">
        <el-form ref="dataClientForm2" :model="dataClient" label-width="0px">
          <el-form-item>
            <el-input v-model="dataClient.comment" :autosize="{ minRows: 3 }" type="textarea"
              placeholder="Ajouter un commentaire"></el-input>
          </el-form-item>
          <el-form-item>
            <el-select v-model="tagsSelected" multiple placeholder="Attribuer un label à la séléction">
              <el-option v-for="t in getAllTags" :key="t.value" :label="t.text" :value="t.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <client-tag v-for="tag in tagsSelected" :key="tag" :idTag="tag" :deletable="true" :cid="cid"></client-tag>
          </el-form-item>
        </el-form>
        <div v-if="getAllResas" class="black-inputs screen-clients">
          <el-table ref="multipleTable" :data="getAllResas">
            <el-table-column prop="formatDate" label="Date" sortable="custom">
            </el-table-column>
            <el-table-column prop="hour" label="Heure" sortable="custom">
            </el-table-column>
            <el-table-column prop="nbCouvert" label="Couverts" sortable="custom">
            </el-table-column>
            <el-table-column>
              <template slot-scope="scope">
                <i class="el-icon-view icon-btn" @click="gotoResa(scope.row)"></i>
              </template>
            </el-table-column>
          </el-table>
          <div class="clients-panel-container" style="text-align: center;margin-top: 30px;">
            <el-pagination background small layout="prev, pager, next" :total="total" @current-change="current_change">
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="10" :offset="1">
        <el-button class="dark" type="primary" @click="closeDialog()">Annuler</el-button>
      </el-col>
      <el-col :span="10" :offset="1">
        <el-button type="primary" @click="validModifications()">Valider</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { Notification } from 'element-ui';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { checkPhone, validatePrefix } from '../../tools/validator';
import ClientTag from './ClientTag';

export default {
  name: 'ClientEdit',
  components: { ClientTag },
  props: ['cid'],
  data() {
    return {
      dataClient: {},
      tagsSelected: [],
      selection: [],
      allResas: null,
      pagesize: 3,
      currentPage: 1,
      total: 0
    }
  },
  computed: {
    ...mapGetters({
      getClientByid: 'newClients/getClientByid',
      getClientByNPC: 'newClients/getClientByNPC',
      getAllTagsData: 'infos/getAllTagsData',
      isVisibleDialogEditClient: 'displayer/isVisibleDialogEditClient',
      getDateToTimestamp: 'calendar/getDateToTimestamp'
    }),
    getTagClient: function () {
      return this.getClientByid(this.cid).tags
    },
    getAllTags: function () {
      let filterArray = []
      Object.entries(this.getAllTagsData).forEach(([idt, t]) => {
        let o = {
          text: t.name,
          value: t.id
        }
        filterArray.push(o)
      })
      return filterArray
    },
    getAllResas: function () {
      if (this.allResas) {
        let resas = this.allResas.slice(0)
        resas.forEach(resa => {
          resa.formatDate = `${this.leadingZero(resa.dateResa.day)}/${this.leadingZero(resa.dateResa.month)}/${resa.dateResa.year}`
          resa.ts = this.getDateToTimestamp({
            day: resa.dateResa.day,
            month: resa.dateResa.month,
            year: resa.dateResa.year
          })
        })
        resas = resas.sort((a, b) => {
          let uA = a.ts
          let uB = b.ts
          if (uA < uB) return 1
          if (uA > uB) return -1
          return 0
        })

        this.total = resas.length
        return resas.slice((this.currentPage - 1) * this.pagesize, this.currentPage * this.pagesize)
      }
      return []
    }
  },
  methods: {
    ...mapActions({
      updateClient: 'newClients/updateClient',
      updateClientByCid: 'newClients/updateClientByCid',
      loadCidResasByResto: 'newReservations/loadCidResasByResto',
      showHidePopupManageServices: 'displayer/showHidePopupManageServices',
      showVisibilityCalendar: 'calendar/showVisibilityCalendar'
    }),
    ...mapMutations({
      setDialogEditClient: 'displayer/setDialogEditClient',
      setSelectedDay: 'calendar/setSelectedDay',
      setSelectedService: 'newServices/setSelectedService',
      setModLinkTable: 'newRooms/setModLinkTable',
      setSelectedResa: 'newReservations/setSelectedResa'
    }),
    current_change: function (currentPage) {
      this.currentPage = currentPage
    },
    leadingZero(value) {
      return (`0${value}`).slice(-2)
    },
    gotoResa: function (resa) {
      this.$emit('bubleclose', false)
      this.setSelectedDay(resa.dateResa)
      this.setSelectedService({ ms: resa.ms, subs: resa.subs })
      this.setSelectedResa(resa)
      this.setModLinkTable(true)
      this.showHidePopupManageServices()
      this.showVisibilityCalendar(false)
    },
    closeDialog: function () {
      this.setDialogEditClient(false)
    },
    applyTag: function () {
      return new Promise((resolve, reject) => {
        let tabTag = []
        if (this.getClientByid(this.cid).tags !== undefined) {
          tabTag = this.getClientByid(this.cid).tags.slice(0)
          this.tagsSelected.forEach((tag) => {
            let found = tabTag.find((st) => {
              return st === tag
            })
            if (found === undefined) tabTag.push(tag)
          })
        } else {
          tabTag = this.tagsSelected.slice(0)
        }
        resolve(tabTag)
      })
    },
    setModifications: function (tags = []) {
      let client = this.getClientByid(this.cid)
      this.dataClient.cid = client.cid
      if (this.dataClient.clientPreFix !== client.clientPreFix) client.clientPreFix = this.dataClient.clientPreFix
      if (this.dataClient.name !== client.name) client.name = this.dataClient.name
      if (this.dataClient.prenom !== client.prenom) client.prenom = this.dataClient.prenom
      if (this.dataClient.telPreFix !== '' && this.dataClient.telPreFix !== client.telPreFix) client.telPreFix = this.dataClient.telPreFix
      if (this.dataClient.tel !== '' && this.dataClient.tel !== client.tel) client.tel = this.dataClient.tel
      if (this.dataClient.email !== '' && this.dataClient.email !== client.email) client.email = this.dataClient.email
      if (this.dataClient.civ !== client.civ) client.civ = this.dataClient.civ
      if (this.dataClient.comment !== client.comment) client.comment = this.dataClient.comment
      if (this.dataClient.societe !== client.societe) client.societe = this.dataClient.societe
      if (this.dataClient.rgpdmail !== client.rgpdmail) client.rgpdmail = this.dataClient.rgpdmail
      if (this.dataClient.rgpdsms !== client.rgpdsms) client.rgpdsms = this.dataClient.rgpdsms
      client.nameLc = this.dataClient.name.toLowerCase()
      client.prenomLc = this.dataClient.prenom.toLowerCase()
      client.tags = tags
      this.updateClientByCid(client).then(() => {
        this.closeDialog()
      }).catch(err => {
        console.error(err)
      })
    },
    validModifications: function () {
      // check phone or telephone exist
      if (this.dataClient.tel === '' && this.dataClient.email === '') {
        Notification.error({
          title: 'Error',
          message: 'Un email ou un numéro de téléphone est nécessaire',
          position: 'bottom-right'
        })
        return false
      }
      this.$refs.dataClientForm.validate((valid) => {
        if (valid) {
          if (this.tagsSelected.length > 0) {
            this.applyTag().then((tags) => {
              this.setModifications(tags)
            })
          } else {
            this.setModifications()
          }
        } else {
          return false
        }
      })
    },
    initClientData: function () {
      this.dataClient = this.getClientByid(this.cid)
      // init tags
      if (this.dataClient.tags === undefined) this.tagsSelected = []
      else this.tagsSelected = this.dataClient.tags
      // init rgpd data
      if (this.dataClient.rgpdmail === undefined) this.dataClient.rgpdmail = false
      if (this.dataClient.rgpdsms === undefined) this.dataClient.rgpdsms = false
      if (this.dataClient.civ === 'Mme.') this.dataClient.civ = this.dataClient.civ.replace('.', '')

      // load all resas
      this.loadCidResasByResto(this.cid).then(res => {
        this.allResas = res
      })
    }
  },
  watch: {
    'isVisibleDialogEditClient': function (val, oldVal) {
      if (val === true) {
        this.initClientData()
      }
    },
    'getTagClient': function (val, oldVal) {
      this.initClientData()
    }
  },
  created: function () {
    this.initClientData()
    this.rulesFormPart1 = {
      email: [
        { type: 'email', message: 'Merci de rentrer une adresse e-mail valide', trigger: 'blur' }
      ],
      name: [
        { required: true, message: 'Merci de rentrer un nom', trigger: 'blur' }
      ],
      prenom: [
        { required: true, message: 'Merci de rentrer un prénom', trigger: 'blur' }
      ],
      tel: [
        { validator: checkPhone, trigger: 'blur' }
      ],
      telPreFix: [
        { validator: (rule, value, callback) => validatePrefix(rule, value, callback, this.dataClient.tel), trigger: 'blur' }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.tel {
  width: 75%;
  margin-left: 1%;
  display: inline-block;

  &-prefix {
    width: 22%;
    display: inline-block;

    input {
      text-align: right;
    }
  }
}

.civ {
  width: 70%;
  display: inline-block;
}

.cPrefix {
  width: 26%;
  margin-left: 2%;
  display: inline-block;
}

.sort-caret.ascending {
  border: 7px solid transparent !important;
  border-bottom-color: #242c45 !important;
  top: 1px !important;
}

.sort-caret.descending {
  border: 7px solid transparent !important;
  border-top-color: #242c45 !important;
  bottom: 1px !important;
}

.el-table .ascending .sort-caret {
  &.ascending {
    border-bottom-color: #00cec0 !important;
  }
}

.el-table .descending .sort-caret {
  &.descending {
    border-top-color: #00cec0 !important;
  }
}

.clients-panel-container {
  padding: 0 0 30px 0;
}

.icon-btn {
  cursor: pointer;
}
</style>
